{
	"dashboard": "Tableau de bord",
	"recoveryContainer": {
		"footerText": "© 2026 Zig The Global Funtech. Tous droits réservés."
	},
	"newLogin": {
		"heroTitle": {
			"prefix": "Zig organise",
			"suffix": "le rythme de votre",
			"words": ["show", "consommation", "événement", "festival", "pub"]
		},
		"labels": {
			"company": "Organisation",
			"login": "Identifiant",
			"password": "Mot de passe"
		},
		"description": "Pour accéder, veuillez remplir les données",
		"fields": {
			"organization": {
				"placeholder": "Entrez le nom de l'organisation",
				"required": "Le nom de l'organisation est requis"
			},
			"username": {
				"placeholder": "Entrez votre identifiant",
				"required": "Votre identifiant est requis"
			},
			"password": {
				"placeholder": "Entrez votre mot de passe",
				"required": "Votre mot de passe est requis"
			}
		},
		"submit": "Se connecter",
		"forgotPassword": {
			"question": "Mot de passe oublié ?",
			"action": "Cliquez ici"
		}
	}
}
